import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import CreateGodMemberForm from './CreateGodMemberForm';
import CreateGodGroupForm from './CreateGodGroupForm';
import CreateShopForm from './CreateShopForm';
import CreateNonMemberForm from './CreateNonMemberForm';
import CreatePaymentForm from './CreatePaymentForm';
import GodReviewModal from './GodReviewModal';
import GodConsumerModal from './GodConsumerModal';

const QUICK_ACTIONS = [
    { id: 'godMember', label: 'New God Member', className: 'text-blue-700 bg-blue-100 hover:bg-blue-200' },
    { id: 'godGroup', label: 'New God Group', className: 'text-emerald-700 bg-emerald-100 hover:bg-emerald-200' },
    { id: 'shop', label: 'New Shop', className: 'text-amber-800 bg-amber-100 hover:bg-amber-200' },
    { id: 'review', label: 'New Review', className: 'text-violet-700 bg-violet-100 hover:bg-violet-200' },
    { id: 'nonMember', label: 'New Non-Member', className: 'text-rose-700 bg-rose-100 hover:bg-rose-200' },
    { id: 'consumer', label: 'New Consumer', className: 'text-indigo-700 bg-indigo-100 hover:bg-indigo-200' },
    { id: 'payment', label: 'New Payment', className: 'text-teal-700 bg-teal-100 hover:bg-teal-200' },
];

const AmberModalShell = ({ children }) => (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-start justify-center pt-8 pb-12">
        <div className="relative max-w-5xl w-full mx-4 bg-amber-50 rounded-lg shadow-lg p-6">
            {children}
        </div>
    </div>
);

const getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'ngrok-skip-browser-warning': 'true',
});

const GodQuickActionsBar = () => {
    const [activeModal, setActiveModal] = useState(null);

    const closeModal = () => setActiveModal(null);

    const handleSuccess = () => closeModal();

    return (
        <>
            <div className="px-4 sm:px-8 py-3 flex flex-wrap items-center gap-2">
                {QUICK_ACTIONS.map((action) => (
                    <button
                        key={action.id}
                        type="button"
                        onClick={() => setActiveModal(action.id)}
                        className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium shadow-md hover:shadow-lg transition-all ${action.className}`}
                    >
                        <FiPlus className="w-4 h-4" /> {action.label}
                    </button>
                ))}
            </div>

            {activeModal === 'godMember' && (
                <AmberModalShell>
                    <CreateGodMemberForm onSuccess={handleSuccess} onCancel={closeModal} />
                </AmberModalShell>
            )}

            {activeModal === 'godGroup' && (
                <AmberModalShell>
                    <CreateGodGroupForm onSuccess={handleSuccess} onCancel={closeModal} />
                </AmberModalShell>
            )}

            {activeModal === 'shop' && (
                <CreateShopForm onSuccess={handleSuccess} onCancel={closeModal} />
            )}

            {activeModal === 'review' && (
                <GodReviewModal
                    onClose={closeModal}
                    onSuccess={handleSuccess}
                    getAuthHeaders={getAuthHeaders}
                />
            )}

            {activeModal === 'nonMember' && (
                <AmberModalShell>
                    <CreateNonMemberForm onSuccess={handleSuccess} onCancel={closeModal} />
                </AmberModalShell>
            )}

            {activeModal === 'consumer' && (
                <GodConsumerModal mode="create" onSuccess={handleSuccess} onCancel={closeModal} />
            )}

            {activeModal === 'payment' && (
                <CreatePaymentForm onSuccess={handleSuccess} onCancel={closeModal} />
            )}
        </>
    );
};

export default GodQuickActionsBar;
